// extracted by mini-css-extract-plugin
module.exports = {"title":"terms-module--title--3PAlf","root":"terms-module--root--3qrWx"};